import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../../core/services/loading.service';
import { LogoComponent } from '../../shared/components/logo/logo.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, LogoComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  loginForm: FormGroup;
  errorMessage: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private translate: TranslateService,
    private loadingService: LoadingService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  async login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.loadingService.show();
    this.errorMessage = '';
    const { email, password } = this.loginForm.value;

    try {
      const userCredential = await this.authService.login(email, password);
      // After login, the auth state listener in AuthService will update currentUser$
      // The guard will then pick up the new user and allow navigation.
      // We just need to wait for the user object to be available to know where to go.
      
      const user = await this.authService.waitForUser(); // A new method we might need in AuthService

      if (user) {
        let targetRoute = '/login'; // Default fallback
        switch (user.role) {
          case 'Administrator':
            targetRoute = '/admin';
            break;
          case 'Coordinator':
            targetRoute = '/coordinator';
            break;
          case 'Technician':
            targetRoute = '/technician';
            break;
        }
        await this.router.navigate([targetRoute]);
      }
    } catch (err) {
      this.errorMessage = this.translate.instant('LOGIN.ERROR');
    } finally {
      this.loadingService.hide();
    }
  }
}
